import { Send, Search } from "react-feather"
import { ComponentPropsWithoutRef, HTMLInputTypeAttribute, ReactNode } from 'react'

export type SearchInputProps = {
  placeholder?: string
  /** Wrapper styles */
  className?: string
  /** Input styles */
  type?: HTMLInputTypeAttribute
  /** Disables the input and shows defaultValue (can be set from React Hook Form) */
  readOnly?: boolean
  /** Disable error style (not disabling error validation) */
  hideError?: boolean
  /** Manual validation using RHF, it is encouraged to use yup resolver instead */
  disabled?: boolean
  onSearchClick?: (val?: any) => void
  SearchIcon?: any
} & ComponentPropsWithoutRef<'input'>

const SearchInput = ({ className, placeholder, SearchIcon = Search, onSearchClick, ...rest }: SearchInputProps) => {
  const classNames = ['search-input']
  if (className) classNames.push(className)

  return (
    <div className={classNames.join(' ')}>
      <input placeholder={placeholder} {...rest} aria-label={placeholder} />
      <button className="search-input__action" onClick={onSearchClick} aria-label="Suche">
        <SearchIcon />
      </button>
    </div>
  )
}

export default SearchInput